import { useContext, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";

import { GrantsAndIncentivesContext } from "common/contexts";
import getGAUserID from "common/fetch/getGAUserID";
import sendData from "common/fetch/post";
import trigger from "common/trigger";

import ButtonNew from "components/atoms/ButtonNew/index";
import { BiLoaderAlt } from "components/atoms/Icon/bi/BiLoaderAlt";
import Img from "components/atoms/Img";
import { InputEmail } from "components/atoms/Input";

export default function StartScreenGrantsIncentives() {
  const {
    register,
    handleSubmit,
    reset,
    clearErrors,
    formState: { isSubmitting, errors },
  } = useForm();

  const recaptchaRef = useRef();
  const { setFirstScreen, setUserData } = useContext(
    GrantsAndIncentivesContext
  );
  const [validated, setValidated] = useState(false);

  const onSubmit = async (data) => {
    const token = await recaptchaRef.current.executeAsync();

    if (token) {
      const GAUserID = getGAUserID();

      const dataSend = { ...data };

      dataSend.contact_from_id = 40;
      dataSend.company_country_id = 191;
      dataSend.client_id = GAUserID ? GAUserID : "";
      dataSend.website_id = process.env.NEXT_PUBLIC_WEBSITE_ID;
      // Await axios
      //   .post(
      //     `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/default`,
      //     Data,
      //     {
      //       Headers: {
      //         "captcha-response": token,
      //       },
      //     }
      // )
      sendData({
        api: `${process.env.NEXT_PUBLIC_ORDER_API_ENDPOINT}/api/portal/contact_form/default`,
        data: dataSend,
        token,
      })
        .then((res) => {
          if (res.state) {
            reset();
            setValidated(false);
            trigger("contact_form", dataSend, "Singapore Grants");
            clearErrors();
            setUserData((prev) => ({ ...prev, email: dataSend.email }));
            setFirstScreen(false);
          } else {
            // Temp position to test local storage
            console.log("error");
          }
        })
        .catch((error) => {
          reset();
          clearErrors();
          setValidated(false);
          console.log(error);
          setUserData({});
        });
    } else {
      reset();
      clearErrors();
      setValidated(false);
      setUserData({});
    }
  };

  return (
    <div className=" mt-10 flex justify-center pt-20 md:mt-20">
      <div className="container">
        <div className="row mb-2.5">
          <div className="order-last grid place-items-center text-center sm:col-12 lg:col-6 lg:order-first lg:text-left">
            <div>
              <h1 className="mb-6">
                <span className="bg-gradient-to-r from-red-800 to-red-500 bg-clip-text text-2xl font-semibold leading-9 text-transparent lg:text-bbc-48px">
                  SINGAPORE
                </span>
                <br />
                <span className="bg-gradient-to-r from-blue-800 to-blue-500 bg-clip-text text-2xl font-semibold leading-9 text-transparent lg:text-bbc-48px">
                  Grants & Incentives
                </span>
              </h1>
              <p className=" mb-12 text-gray-400 ">
                Type in your contact information to receive details about
                supporting programs in Singapore
              </p>
              <form
                noValidate
                validated={validated ? 1 : 0}
                onSubmit={handleSubmit(onSubmit)}
                className="relative mx-auto  lg:mx-0"
                style={{ maxWidth: "540px" }}
              >
                <InputEmail
                  register={register}
                  errors={errors}
                  name="email"
                  placeholder="Your email"
                  className="w-full rounded-full border border-bbc-neutral-400 py-2 px-4 leading-8 text-bbc-gray placeholder-gray-400 focus:border-bbc-neutral-400 focus:ring-0"
                />
                <div className=" mt-4 grid justify-center lg:mt-8 lg:justify-start">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={process.env.NEXT_PUBLIC_G_RECAPTCHA_V3_SITE_KEY}
                    badge="inline"
                    size="invisible"
                  />
                </div>
                <div className="mt-4 mb-10 block text-center lg:mb-0 lg:inline-block">
                  <ButtonNew
                    disabled={isSubmitting}
                    othersClass="uppercase lg:w-auto lg:absolute right-1 top-1 flex mx-auto"
                    onClick={() => {
                      setValidated(true);
                    }}
                  >
                    {isSubmitting ? (
                      <>
                        <BiLoaderAlt className="mr-2 animate-spin" size={20} />
                        <p>Loading</p>
                      </>
                    ) : (
                      "Start Now"
                    )}
                  </ButtonNew>
                </div>
              </form>
            </div>
          </div>
          <div className="items-center sm:col-12 sm:order-1 sm:flex lg:col-6">
            <Img
              src="/assets/images/sg/guide-and-tool/singapore-grants-incentives/singapore-sg-grants.png"
              alt="singapore-grants-incentives"
              loading="lazy"
              className="mb-10 lg:mb-0"
              width={540}
              height={402}
            />
          </div>
        </div>
        <p className="mb-6 font-medium text-gray-600">Disclaimer</p>
        <p className=" text-gray-600">
          The information contained in this tool is for general information
          purpose only. You should not substitute the information provided in
          this tool for competent legal advice. For a further in-depth
          understanding of Singapore grants & incentives, please engage
          professional advice.
        </p>
      </div>
    </div>
  );
}
